import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RecaptchaService } from './recaptcha.service';
import { RECAPTCHA_V3_SITE_KEY } from './recaptcha.token';
import { environment } from '../../../environments/environment';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [RecaptchaService],
})
export class NDBSRecaptchaModule {
  static forRoot(): ModuleWithProviders<NDBSRecaptchaModule> {
    return {
      ngModule: NDBSRecaptchaModule,
      providers: [{ provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.recaptchaKey }],
    };
  }
}
